module.exports = __webpack_public_path__ + "img/0adef84.svg";